// Api  
import api from '@/api/baseApi';

// Extend
import base from '@/scripts/base';

// Constant
import { SETTINGS_USER_API } from "@/constant/apiSettings";
import { API_CALL_STATUS } from "@/constant/baseConstant";
import { GPURENTAL_STATUS_CODE } from "@/constant/config";
import CodeInput from "vue-verification-code-input";

export default {

    extends: base,
    components: {
        CodeInput
    },
    data() {
        return {
            delayNotification: 1000,
            isLoading: false,
            isEnabledTwoFactorAuthServerState: false,
            isEnabledTwoFactorAuth: false,
            isShowTwoFactorAuthCode: false,
            centerDialogVisible: false,
            cancelPINDialogAction: null,
            submitPINDialogAction: null,
            pinInputCompleted: false,
            pinInputValue: '',
            pinSubmitError: null,
            twoFactorAuthInfo: {
                setupCode: '',
                barcodeImageUrl: ''
            },
            enableTwoFactorAuth: {
                twoFactorAuthentionCode: '', 
                deviceInformation: null,
            }
        };
    },
    watch: {
        isEnabledTwoFactorAuth(newVal) {
            if (!newVal && this.isEnabledTwoFactorAuthServerState) {
                this.showPinCodeInput(() => {
                    this.isEnabledTwoFactorAuth = true;
                }, () => {
                    this.submitDisableTwoFactorAuthentication();
                });
            }
            if(newVal) {
                this.getTwoFactorAuthInfo();
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.getIsEnabledTwoFactorAuthInfo();
        });
    },
    methods: {
        getIsEnabledTwoFactorAuthInfo() {
            api.baseRequest(SETTINGS_USER_API.IS_ENABLE_TWO_FACTOR_AUTH)
                .then((res) => {
                    if (res.data) this.getTwoFactorAuthInfo();
                    this.$set(this, 'isEnabledTwoFactorAuth', res.data);
                    this.$set(this, 'isEnabledTwoFactorAuthServerState', res.data);
                })
                .catch(error => {
                    this.processCatchApiRequest(error, this.$t('twoFactorAuth.getStatusFailed'))
                });
        },
        getTwoFactorAuthInfo() {
            api.baseRequest(SETTINGS_USER_API.GET_TWO_FACTOR_AUTH_INFO)
                .then((res) => {
                    this.$set(this.twoFactorAuthInfo, 'setupCode', res.data.setupCode);
                    this.$set(this.twoFactorAuthInfo, 'barcodeImageUrl', res.data.barcodeImageUrl);
                })
                .catch(error => {
                    this.processCatchApiRequest(error, this.$t('twoFactorAuth.getInfoFailed'))
                });
        },
        submitEnableTwoFactorAuthentication() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            this.enableTwoFactorAuth.twoFactorAuthentionCode = this.pinInputValue;
            this.enableTwoFactorAuth.deviceInformation = JSON.stringify(this.getInformationClient());
            api.baseRequest(SETTINGS_USER_API.ENABLE_TWO_FACTOR_AUTH, this.enableTwoFactorAuth)
                .then((res) => {
                    console.log(res);
                    this.getIsEnabledTwoFactorAuthInfo();
                    this.resetAll();
                    this.isLoading = false;
                })
                .catch(error => {
                    if (error.errorCode === GPURENTAL_STATUS_CODE.EnableTwoFactorAuth_PinInvalid) {
                        this.pinSubmitError = error.message;
                    }
                    else this.processCatchApiRequest(error, this.$t('twoFactorAuth.enableFailed'));
                    this.isLoading = false;
                });
        },
        submitDisableTwoFactorAuthentication() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            this.enableTwoFactorAuth.twoFactorAuthentionCode = this.pinInputValue;
            this.enableTwoFactorAuth.deviceInformation = JSON.stringify(this.getInformationClient());
            api.baseRequest(SETTINGS_USER_API.DISABLE_TWO_FACTOR_AUTH, this.enableTwoFactorAuth)
                .then((res) => {
                    this.getIsEnabledTwoFactorAuthInfo();
                    this.resetAll();
                    this.$set(this.twoFactorAuthInfo, 'setupCode', '');
                    this.$set(this.twoFactorAuthInfo, 'barcodeImageUrl', '');
                    this.isLoading = false;
                    res;
                })
                .catch(error => {
                    if (error.errorCode === GPURENTAL_STATUS_CODE.EnableTwoFactorAuth_PinInvalid) {
                        this.pinSubmitError = error.message;
                    }
                    else this.processCatchApiRequest(error, this.$t('twoFactorAuth.disableFailed'));
                    this.isLoading = false;
                });
        },
        showPinCodeToEnable() {
            this.showPinCodeInput(() => {
                this.isEnabledTwoFactorAuth = false;
            }, () => {
                this.submitEnableTwoFactorAuthentication();
            });
        },
        showPinCodeInput(cancelAction, confirmAction) {
            this.cancelPINDialogAction = cancelAction;
            this.submitPINDialogAction = confirmAction;
            this.centerDialogVisible = true;
            this.$nextTick(() => {
                $('.PIN-CODE .react-code-input > input:first-child').focus();
            });
        },
        onPINChange(v) {
            if (v.length < 6) {
                this.pinInputCompleted = false;
                this.pinInputValue = v;
            }
        },
        onPINComplete(v) {
            if (v.length === 6) {
                this.pinInputCompleted = true;
                this.pinInputValue = v;
            }
        },
        resetAll() {
            this.pinInputCompleted = false;
            this.pinInputValue = '';
            this.centerDialogVisible = false;
            this.pinSubmitError = null;
            $('.PIN-CODE .react-code-input > input').val('');
            $('.PIN-CODE .react-code-input > input:first-child').focus();
            this.isLoading = false;
        }
    }
};